var app = {
	header: {
		build: "สร้าง",
		closeButton: "ปิด",
		copyrightLabel: "ลิขสิทธิ์",
		helpLabel: "ช่วยเหลือ",
		legalNoticeLabel: "ข้อปฏิบัติทางกฎหมาย",
		logoutButton: "ออกจากระบบ",
		menuLabel: "เมนู",
		module: "โมดูล",
		noUserDataLabel: "ไม่มีข้อมูลผู้ใช้",
		notificationsLabel: "การแจ้งเตือน",
		privacyPolicyLabel: "นโยบายความเป็นส่วนตัว",
		serviceAppLabel: "แอปพลิเคชันบริการ",
		settingsLabel: "การตั้งค่า",
		shopLabel: "ร้านค้า",
		smartFactorySuiteLabel: "ชุดสมาร์ทแฟคทอรี",
		softwareInformation: "ข้อมูลซอฟต์แวร์",
		userLabel: "โปรไฟล์",
		userProfileLinkText: "โปรไฟล์ผู้ใช้",
		version: "เวอร์ชัน"
	}
};
var contentLoadingError = "ไม่สามารถโหลดเนื้อหาได้";
var dashboard = {
	cancel: {
		button: "ยกเลิก"
	},
	edit: {
		button: "แก้ไข"
	},
	reset: {
		button: "รีเซ็ต"
	},
	save: {
		button: "บันทึก"
	},
	share: {
		button: "แชร์"
	}
};
var filter = {
	clear: "รีเซ็ตตัวกรอง",
	clearAll: "รีเซ็ตตัวกรองทั้งหมด"
};
var locationMap = {
	locationLink: {
		label: "ไปยังตำแหน่ง"
	}
};
var machineDiscontinuation = {
	linkText: "เรียนรู้เพิ่มเติม"
};
var notifications = {
	button: {
		loadMore: "โหลดเพิ่ม"
	},
	date: {
		lastMonth: "เดือนที่แล้ว",
		lastWeek: "สัปดาห์ที่แล้ว",
		older: "เก่ากว่า",
		thisMonth: "เดือนนี้",
		thisWeek: "สัปดาห์นี้",
		today: "วันนี้",
		yesterday: "เมื่อวาน"
	},
	error: {
		general: "ขณะนี้ไม่สามารถแสดงการแจ้งเตือนได้ โปรดลองอีกครั้งในภายหลัง",
		unauthorized: "กรุณาเข้าสู่ระบบเพื่อดูการแจ้งเตือน"
	},
	info: {
		activateSettings: "เพื่อรับการแจ้งเตือน โปรดเปิดใช้งานในการตั้งค่า",
		noNotification: "ขณะนี้ไม่มีข้อความสำหรับคุณ"
	},
	title: "การแจ้งเตือน"
};
var results = {
	counter: {
		label: "ผลลัพธ์ รายการ"
	}
};
var scrollToTop = {
	label: "เลื่อนไปที่ด้านบน"
};
var slider = {
	nextButton: {
		label: "ภาพถัดไป"
	},
	paginationBullet: {
		label: "ภาพ"
	},
	prevButton: {
		label: "ภาพก่อนหน้า"
	}
};
var sorting = {
	ascending: "เรียงลำดับจากน้อยไปมาก",
	descending: "เรียงลำดับจากมากไปน้อย"
};
var userAccount = {
	address: {
		label: "ที่อยู่ไปรษณีย์"
	},
	email: {
		label: "อีเมล"
	},
	language: {
		label: "ภาษา",
		locale: "ภาษา",
		select: "เลือกภาษา",
		settings: "การตั้งค่าภาษา"
	},
	loggedOut: {
		message: "คุณไม่ได้เข้าสู่ระบบ"
	},
	login: {
		button: "เข้าสู่ระบบ"
	},
	name: {
		label: "ชื่อ"
	},
	phone: {
		label: "โทรศัพท์"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "กรองเครื่อง",
			label: "เครื่อง",
			option: {
				all: "ทุกเครื่อง"
			},
			select: "เลือกเครื่อง"
		},
		period: {
			label: "ระยะเวลา",
			option: {
				currentMonth: "เดือนนี้",
				currentWeek: "สัปดาห์นี้",
				lastMonth: "เดือนที่แล้ว",
				lastWeek: "สัปดาห์ที่แล้ว",
				today: "วันนี้",
				yesterday: "เมื่อวาน"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "วิดเจ็ตของฉัน"
	},
	noDescriptionAvailable: "ไม่มีคำอธิบาย",
	widget: {
		SampleMyMachines: {
			title: "เครื่องของฉัน"
		},
		SampleMyServiceCalls: {
			title: "การเรียกใช้บริการ"
		},
		SampleMyTrackingList: {
			title: "รายการติดตาม"
		},
		SampleMyUserAccount: {
			title: "โปรไฟล์ของฉัน"
		},
		SampleOperationalStatesChart: {
			title: "สถานะการทำงาน"
		},
		SampleWidgetFilter: {
			title: "การตั้งค่าฟิลเตอร์"
		},
		SampleWorkloadBalanceChart: {
			title: "ความสมดุลของภาระงาน"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	filter: filter,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, filter, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };
